export default {
      id: "planner-results-usage",
      viewBox: "0 0 16 12",
      url: __webpack_public_path__ + "img/icons.ea6ea76b.svg#planner-results",
      toString: function () {
        return this.url;
      }
    }